/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_iupac_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GGNCC → GG[ACGT]CC (matches GGACC, GGCCC, GGGCC, GGTCC).`)
};

const es_iupac_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GGNCC → GG[ACGT]CC (coincide con GGACC, GGCCC, GGGCC, GGTCC).`)
};

const de_iupac_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GGNCC → GG[ACGT]CC (passt auf GGACC, GGCCC, GGGCC, GGTCC).`)
};

const nl_iupac_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GGNCC → GG[ACGT]CC (komt overeen met GGACC, GGCCC, GGGCC, GGTCC).`)
};

const fr_iupac_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GGNCC → GG[ACGT]CC (correspond à GGACC, GGCCC, GGGCC, GGTCC).`)
};

const it_iupac_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GGNCC → GG[ACGT]CC (corrisponde a GGACC, GGCCC, GGGCC, GGTCC).`)
};

const pt_br2_iupac_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GGNCC → GG[ACGT]CC (corresponde a GGACC, GGCCC, GGGCC, GGTCC).`)
};

const pt_iupac_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GGNCC → GG[ACGT]CC (corresponde a GGACC, GGCCC, GGGCC, GGTCC).`)
};

const ja_iupac_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GGNCC → GG[ACGT]CC（GGACC、GGCCC、GGGCC、GGTCCにマッチ）。`)
};

const zh_iupac_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GGNCC → GG[ACGT]CC（匹配 GGACC、GGCCC、GGGCC、GGTCC）。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const iupac_ex1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.iupac_ex1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("iupac_ex1", locale)
	if (locale === "en") return en_iupac_ex1(inputs)
	if (locale === "es") return es_iupac_ex1(inputs)
	if (locale === "de") return de_iupac_ex1(inputs)
	if (locale === "nl") return nl_iupac_ex1(inputs)
	if (locale === "fr") return fr_iupac_ex1(inputs)
	if (locale === "it") return it_iupac_ex1(inputs)
	if (locale === "pt-BR") return pt_br2_iupac_ex1(inputs)
	if (locale === "pt") return pt_iupac_ex1(inputs)
	if (locale === "ja") return ja_iupac_ex1(inputs)
	return zh_iupac_ex1(inputs)
};